import { format, parseISO } from 'date-fns';

export const formatShortDate = (value: string) => {
  try {
    return format(parseISO(value), 'dd/MM/yyyy');
  } catch {
    return '';
  }
};
